import type { Dayjs } from 'dayjs'
import lt from 'dayjs/locale/lt'

interface ICustomLocale extends Omit<ILocale, 'monthsShort' | 'weekdaysShort'> {
  weekdaysShort: string[] | ((dayjsInstance: Dayjs, format: string) => string)
  monthsShort: string[] | ((dayjsInstance: Dayjs, format: string) => string)
}

const locale: ICustomLocale = {
  ...lt,
  name: 'lt',
  weekStart: 1,
  weekdaysShort: (dayjsInstance: Dayjs, format: string): string => {
    const extended = 'S_P_A_T_K_Pn_Š'.split('_')
    const standard = 'sek_pir_ant_tre_ket_pen_šeš'.split('_')

    if (/^EXT_/.test(format)) {
      return extended[dayjsInstance.day()]
    } else {
      return standard[dayjsInstance.day()]
    }
  },
  monthsShort: (dayjsInstance: Dayjs, format: string): string => {
    const extended = 'Saus._Vas._Kov._Bal._Geg._Birž._Liep._Rugpj._Rugs._Spal._Lapkr._Gruod.'.split('_')
    const standard = 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_')

    if (/^EXT_/.test(format)) {
      return extended[dayjsInstance.month()]
    } else {
      return standard[dayjsInstance.month()]
    }
  }
}

export default locale
